import { Button } from 'antd';
import classNames from 'classnames/bind';
import LINK from 'constants/link';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { isHiddenPath } from 'utils/locale';
import styles from './CareerSection.module.css';

const cx = classNames.bind(styles);

const RECRUIT_JOBS_PATH = '/career/jobs';

function CareerSection() {
  const { t: ct } = useTranslation('common');
  const { locale } = useRouter();
  const isRecruitVisible = !isHiddenPath({ path: RECRUIT_JOBS_PATH, locale });

  const label = `${ct('browse-jobs')} →`;

  return (
    <section className={cx('career')}>
      <strong className={cx('title')}>{ct('join-journey')}</strong>
      <Button type="primary" shape="round">
        {isRecruitVisible ? (
          <Link href={RECRUIT_JOBS_PATH}>
            <a>{label}</a>
          </Link>
        ) : (
          <a href={LINK['apply-workable']} target="_blank" rel="noreferrer">
            {label}
          </a>
        )}
      </Button>
    </section>
  );
}

export default CareerSection;
